const currencies = {
  USD: 'USD',
};

export const getDisplayPrice = (
  priceAmt = '',
  currencyType = currencies.USD
) => {
  if (currencyType === currencies.USD) {
    // show decimal amounts if they exist
    const displayPrice =
      priceAmt % 1 < 1 && priceAmt % 1 > 0 ? priceAmt.toFixed(2) : priceAmt;
    // get as string with commas where necessary
    const strPrice = displayPrice
      .toString()
      .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    // prepend $
    return `$${strPrice}`;
  }

  return priceAmt.toString();
};

export default getDisplayPrice;



// WEBPACK FOOTER //
// ./src/common/utils/format-currency/index.js